<template>
  <div :class="{ desktop: $media.desktop, 'last-step': current === total }" class="app-progress">
    <div :style="{ width: `${progress}%` }" class="progress-bar">
      <div class="label">{{ current }} / {{ total }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AppProgress',
    props: {
      total: {
        type: Number,
        required: true,
      },
      current: {
        type: Number,
        required: true,
      },
    },
    computed: {
      progress() {
        return this.current / this.total * 100;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .app-progress {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 0.7rem;
    background-color: #E1E1E1;
  }

  .progress-bar {
    background: $appProgressColor;
    height: 0.7rem;
    transition: width 500ms linear;
  }

  .label {
    text-align: right;
    position: relative;
    top: 1rem;
    font-size: 1.4rem;
  }

  .last-step .label {
    padding-right: 1rem;
  }
</style>
